import { Link } from "react-router";

import { PATHS } from "../routes/routes.constants.ts";
import { WitnessLines } from "./WitnessLines.tsx";
import { WITNESS_COPY } from "./witness.constants.ts";
import { useWitnessController } from "./useWitnessController.ts";
import "./witness.css";

/**
 * The Record tab — OND-53. What the witness says about this work.
 *
 * EVERY SENTENCE HERE IS FROM `witness.constants.ts`, and every decision is
 * `toWitnessPanel`'s: the view switches on the panel's kind and prints what it
 * was handed. The one thing it adds is the download, which is a browser act.
 */
export function WitnessPanel({ workId }: { workId: string }) {
  const { panel, downloadBundle } = useWitnessController(workId);

  return (
    <section className="witness" aria-label={WITNESS_COPY.title}>
      <header className="witness__head">
        <p className="witness__help">{WITNESS_COPY.help}</p>
        <p className="witness__limit">{WITNESS_COPY.limit}</p>
      </header>

      {panel.kind === "loading" && <p className="witness__quiet">{panel.message}</p>}
      {panel.kind === "failed" && (
        <p className="witness__quiet" role="status">
          {panel.message}
        </p>
      )}
      {panel.kind === "empty" && <p className="witness__quiet">{panel.message}</p>}

      {panel.kind === "listed" && (
        <>
          <p className="witness__summary">
            {panel.anchored} of {panel.total} witnessed states anchored
          </p>
          <WitnessLines lines={panel.lines} />

          {downloadBundle && (
            <div className="witness__actions">
              <button type="button" className="witness__download" onClick={downloadBundle}>
                {WITNESS_COPY.download}
              </button>
              <p className="witness__note">{WITNESS_COPY.downloadNote}</p>
              <p className="witness__note">
                <Link className="witness__link" to={PATHS.proof}>
                  {WITNESS_COPY.checkElsewhere}
                </Link>
              </p>
            </div>
          )}
        </>
      )}
    </section>
  );
}
